import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const JOBACCESS30MINUTETRANSITDIFF_LAYER_ID =
  'jobAccess30minuteTransitDiffInvAnyLayer';

const layerConfig = {
  title: 'Job Access 30 Minute Transit Difference',
};

function JobAccess30minuteTransitDiffLayer() {
  const dispatch = useDispatch();
  const { jobAccess30minuteTransitDiffInvAnyLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, jobAccess30minuteTransitDiffInvAnyLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (jobAccess30minuteTransitDiffInvAnyLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: JOBACCESS30MINUTETRANSITDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: jobAccess30minuteTransitDiffInvAnyLayer.visible,
      opacity: jobAccess30minuteTransitDiffInvAnyLayer.opacity,
      getFillColor: colorBins({
        attr: 'job_access_30minute_transit_diff',
        domain: [-19136, -7780.471, -4364.201, -2321.19, -658.114, 0, 241288],
        colors: [
          [139, 0, 0],
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 153, 153],
          [255, 204, 204],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: JOBACCESS30MINUTETRANSITDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['job_access_30minute_transit_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default JobAccess30minuteTransitDiffLayer;
